<template>
    <div class="history-flowliga shadow-inactive">
        <div class="history-container">
            <div class="flowliga-report">
                <div class="match-details">
                    <div class="gamenumber details-container">
                        <div class="flowreport-label">Spielnummer</div>
                        <div class="flowreport-value">{{gamenumber}}</div>
                    </div>
                    <div class="phase details-container">
                        <div class="flowreport-label">Phase</div>
                        <div class="flowreport-value">{{phase}}</div>
                    </div>
                    <div class="datum details-container">
                        <div class="flowreport-label">Datum</div>
                        <div class="flowreport-value">{{moment(datum).format("DD.MM.YYYY HH:mm")}}</div>
                    </div>
                    <div class="spieler1">
                        <div class="name details-container">
                            <div class="flowreport-label">Name Spieler 1</div>
                            <div class="flowreport-value">{{player1name}}</div>
                            <div class="winnermark">{{winnerCheck(0)}}</div>
                        </div>
                        <div class="180s details-container">
                            <div class="flowreport-label">180er</div>
                            <div class="flowreport-value">{{player1_180}}</div>
                        </div>
                        <div class="1702 details-container">
                            <div class="flowreport-label">171er</div>
                            <div class="flowreport-value">{{player1_171}}</div>
                        </div>
                    </div>
                    <div class="flowreport-header winnermark-label">Sieger</div>
                    <div class="spieler2">
                        <div class="name details-container">
                            <div class="winnermark">{{winnerCheck(1)}}</div>
                            <div class="flowreport-label">Name Spieler 2</div>
                            <div class="flowreport-value">{{player2name}}</div>
                        </div>
                        <div class="180s details-container">
                            <div class="flowreport-label">180er</div>
                            <div class="flowreport-value">{{player2_180}}</div>
                        </div>
                        <div class="1702 details-container">
                            <div class="flowreport-label">171er</div>
                            <div class="flowreport-value">{{player2_171}}</div>
                        </div>
                    </div>
                </div>
                <div class="match-report">
                    <div class="headers">
                        <div class="flowreport-header header-1fr">Finish</div>
                        <div class="flowreport-header header-2fr">Restpunkte</div>
                        <div class="flowreport-header header-1fr">Leg</div>
                        <div class="flowreport-header header-2fr">Restpunkte</div>
                        <div class="flowreport-header header-1fr">Finish</div>
                    </div>
                    <div class="legs">
                        <div :class="['leg leg-'+(i+1)]" v-for="leg, i in legs" :key="i">
                            <div class="leg-player-finish">{{leg[0]}}</div>
                            <div class="leg-player-restpunkte">{{leg[1]}}</div>
                            <div class="leg-number">{{i+1}}</div>
                            <div class="leg-player-restpunkte">{{leg[2]}}</div>
                            <div class="leg-player-finish">{{leg[3]}}</div>

                        </div>
                    </div>
                    <div class="report-summary">
                        <div class="grid-row">
                            <div class="flowreport-header">Highest Finish</div>
                            <div class="highest-finish-player1">{{player1_highestcheckout}}</div>
                            <div class="restpunkte-player1">{{player1_result}}</div>
                            <div class="flowreport-header">Punkte Gesamt</div>
                            <div class="restpunkte-player2">{{player2_result}}</div>
                            <div class="highest-finish-player2">{{player2_highestcheckout}}</div>
                            <div class="flowreport-header">Highest Finish</div>
                        </div>
                        <div class="grid-row">
                            <div class="flowreport-header">Average</div>
                            <div class="average-player1" v-html="player1_average"></div>
                            <div class="flowreport-header"></div>
                            <div class="differenz">
                                Differenz<br>
                                {{difference}}
                            </div>
                            <div class="flowreport-header"></div>
                            <div class="average-player2" v-html="player2_average"></div>
                            <div class="flowreport-header">Average</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['player'],
    data() {
        return {
            players: null,
            loaded: false,

            data: null,
            datum: '',
            player1name: '',
            player2name: '',
            gamenumber: '',
            phase: '1',
            player1_180: 0,
            player2_180: 0,
            player1_171: 0,
            player2_171: 0,
            player1_highestcheckout: 0,
            player2_highestcheckout: 0,
            player1_average: 0,
            player2_average: 0,
            player1_result: 0,
            player2_result: 0,
            difference: 0,
            legs: []
        }
    },
    mounted() {
        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },
    methods: {
        update(data) {
            if (data == null) return;
            this.data = data;
            if (this.players == null) {
                this.players = data.players;
            }
            if (!data.players[1]) {
                data.players[1] = {player: {}}
            }
            this.history = data.gameState.history;
            //set variables
            this.player1name = data.players[0].player.name;
            this.player2name = data.players[1].player.name;

            if (data.gameStats) {
                this.player1_180 = data.gameStats.players[0].count180;
                this.player1_171 = data.gameStats.players[0].count171;
                this.player2_180 = data.gameStats.players[1].count180;
                this.player2_171 = data.gameStats.players[1].count171;
                this.player1_highestcheckout = data.gameStats.players[0].highest_checkout;
                this.player2_highestcheckout = data.gameStats.players[1].highest_checkout;
                this.player1_average = data.gameStats.players[0].avg3;
                this.player2_average = data.gameStats.players[1].avg3;
            }
            data.game.options.forEach(element => {
                if (element.name == 'gamenumber') this.gamenumber = element.value;
            });
            this.datum = data.game.created_at;

            //legs
            this.legs = [];
            this.player1_result = 0;
            this.player2_result = 0;
            this.difference = 0;
            if (data.legStats) {
                for (let i = 0; i < 5; i++) {
                    if (data.legStats.data[0].legoverview[i]) {
                        var legdata = [];
                        if (data.legStats.data[0] && data.legStats.data[0].legoverview[i]) {
                            legdata.push(data.legStats.data[0].legoverview[i].finish);
                            legdata.push(data.legStats.data[0].legoverview[i].rest);
                        }
                        if (data.legStats.data[1] && data.legStats.data[1].legoverview[i]) {
                            legdata.push(data.legStats.data[1].legoverview[i].rest);
                            legdata.push(data.legStats.data[1].legoverview[i].finish);
                        } else {
                            legdata.push(0);
                            legdata.push("");
                        }
                        this.legs.push(legdata)
                        this.player1_result += data.legStats.data[0].legoverview[i].rest;
                        this.player2_result += data.legStats.data[1].legoverview[i].rest;
                        this.difference = this.player1_result > this.player2_result ? this.player1_result - this.player2_result : this.player2_result - this.player1_result;
                    }
                }
            } else {
                this.player1_180 = 0;
                this.player1_171 = 0;
                this.player2_180 = 0;
                this.player2_171 = 0;
                this.player1_highestcheckout = 0;
                this.player2_highestcheckout = 0;
                for (let i = 0; i < 5; i++) {
                    if (data.gameState && data.gameState.legoverview[0] && data.gameState.legoverview[0][i]) {
                        if (!data.gameState.legoverview[1]) {
                            data.gameState.legoverview[1] = []
                            data.gameState.scores[1] = {};
                            data.gameState.scores[1].stats = {'avg3': 0, 'avg1': 0};
                        }
                        if (!data.gameState.legoverview[1][i]) {
                            data.gameState.legoverview[1][i] = {
                                'finish': 0,
                                'rest': 501,
                                '180s': 0,
                                '171s': 0,
                                'avg3': 0,
                            }
                        }
                        this.legs.push([
                            data.gameState.legoverview[0][i].finish,
                            data.gameState.legoverview[0][i].rest,
                            data.gameState.legoverview[1][i].rest,
                            data.gameState.legoverview[1][i].finish
                        ])
                        this.player1_180 += data.gameState.legoverview[0][i]['180s'];
                        this.player1_171 += data.gameState.legoverview[0][i]['171s'];
                        this.player2_180 += data.gameState.legoverview[1][i]['180s'];
                        this.player2_171 += data.gameState.legoverview[1][i]['171s'];
                        this.player1_result += data.gameState.legoverview[0][i].rest;
                        this.player2_result += data.gameState.legoverview[1][i].rest;
                        this.player1_average = data.gameState.legoverview[0][i].avg3.toFixed(2);
                        this.player2_average = data.gameState.legoverview[1][i].avg3.toFixed(2);
                        this.player1_highestcheckout = this.player1_highestcheckout < data.gameState.legoverview[0][i].finish ? data.gameState.legoverview[0][i].finish : this.player1_highestcheckout;
                        this.player2_highestcheckout = this.player2_highestcheckout < data.gameState.legoverview[1][i].finish ? data.gameState.legoverview[1][i].finish : this.player2_highestcheckout;
                        this.difference = this.player1_result > this.player2_result ? this.player1_result - this.player2_result : this.player2_result - this.player1_result;
                    }
                }
            }
            this.loaded = true;
        },
        winnerCheck(playerIndex) {
            if (this.data == null) return;
            let i = 0;
            var returnValue = '';
            this.players.forEach(player => {
                if (playerIndex == i) {
                    if (this.data.game.winner_id == player.player_id) returnValue =  "X"
                    else returnValue = " - - - "
                }
                i+=1;
            });
            return returnValue;
        }
    }
}
</script>
